let mainTemp = {
        LPINN:'',
        AddressFact:'',
        OGRN:'',
        WebSite:'',
        OKPO:'',
        Phone:'',
        RegDatev:'',
        StartDate:'',
        EmployeesNumber:'',
        DirectorLName:'',
        DirectorPosition:'',
        DirectorBD:'',
        DirectorFName:'',
        DirectorMName:'',
        SignerLName:'',
        SignerPosition:'',
        SignerBD:'',
        SignerFName:'',
        SignerMName:'',
        DocType:'',
        DocNumber:'',
        DocDate:'',
        ContactLName:'',
        ContactPosition:'',
        ContactBD:'',
        ContactFName:'',
        ContactMName:''
    }


let FounderFL = {
    type: true,
    FounderFLShare:'',
    FounderFLFName:'',
    FounderFLMName:'',
    FounderFLBD:'',
    FounderFLBPlace:'',
    FounderFLPassportSN:'',
    FounderFLPassPlace:'',
    FounderFLCitizenship:'',
    FounderFLPassDate:'',
    FounderFLPassPCode:'',
    FounderFLRegistration:''
}


let FounderUL = {
    type: false,
    FounderULINN:'',
    FounderULShare:'',
    FounderULIOGRN:'',
    FounderULName:''
}


let Beneficiary = {
        BeneficiaryLName:'',
        BeneficiaryTel:'',
        BeneficiaryFName:'',
        BeneficiaryEmail:'',
        BeneficiaryMName:'',
        BeneficiaryINN:'',
        BeneficiaryRegistration:'',
        BeneficiaryBD:'',
        BeneficiaryBPlace:'',
        BeneficiaryPassportSN:'',
        BeneficiaryPassPlace:'',
        BeneficiaryCitizenship:'',
        BeneficiaryPassDate:'',
        BeneficiaryPassPCode:'',
        BeneficiaryDocName:'',
        BeneficiaryDocNumber:'',
        BeneficiaryDocDate:''
    }


let LPActivityType = {
        LPActivityTypeName:'',
        LPActivityTypeRevenueShare:''
    }


let LPPartner = {
        LPPartnerName:''
    }


let Credit = {
        Creditor:'',
        CreditAmount:'',
        CreditBalance:'',
        CreditEndDate:''
    }


let BankAccount = {
        BankAccountNumber:'',
        BankAccountName:'',
        BankAccountCode:''
    }


let AppLeasingId = {
    AdditionalInfo:''
}


let temp = {
    "s": "success",
    "data": {
      "msg": "",
      "Data": {
        "LPINN": "4353478990",
        "AddressFact": "testw",
        "AdditionalInfo": "testw",
        "OGRN": "",
        "WebSite": "",
        "OKPO": "",
        "Phone": "",
        "RegDatev": "",
        "StartDate": "",
        "EmployeesNumber": "",
        "DirectorLName": "",
        "DirectorPosition": "",
        "DirectorBD": "",
        "DirectorFName": "",
        "DirectorMName": "",
        "SignerLName": "",
        "SignerPosition": "",
        "SignerBD": "2021-05-19",
        "SignerFName": "",
        "SignerMName": "",
        "DocType": "",
        "DocNumber": "e",
        "DocDate": "",
        "ContactLName": "",
        "ContactPosition": "",
        "ContactBD": "",
        "ContactFName": "",
        "ContactMName": "",
        "FounderFL": [
          {
            "type": true,
            "FounderFLFName": "",
            "FounderFLShare": "",
            "FounderFLMName": "",
            "FounderFLBD": "",
            "FounderFLBPlace": "",
            "FounderFLPassportSN": "",
            "FounderFLPassPlace": "",
            "FounderFLCitizenship": "",
            "FounderFLPassDate": "",
            "FounderFLPassPCode": "",
            "FounderFLRegistration": "",
            "FounderFLLName": ""
          },{
            "type": true,
            "FounderFLFName": "Test",
            "FounderFLShare": "Test",
            "FounderFLMName": "Test",
            "FounderFLBD": "Test",
            "FounderFLBPlace": "Test",
            "FounderFLPassportSN": "Test",
            "FounderFLPassPlace": "Test",
            "FounderFLCitizenship": "Test",
            "FounderFLPassDate": "Test",
            "FounderFLPassPCode": "Test",
            "FounderFLRegistration": "Test",
            "FounderFLLName": "Test"
          },
          {
            "type": true,
            "FounderFLFName": "123123",
            "FounderFLShare": "12321",
            "FounderFLMName": "123123",
            "FounderFLBD": "",
            "FounderFLBPlace": "",
            "FounderFLPassportSN": "",
            "FounderFLPassPlace": "",
            "FounderFLCitizenship": "",
            "FounderFLPassDate": "",
            "FounderFLPassPCode": "",
            "FounderFLRegistration": "",
            "FounderFLLName": "123213"
          }
        ],
        "FounderUL": [
          {
            "type": false,
            "FounderULINN": "",
            "FounderULShare": "",
            "FounderULIOGRN": "",
            "FounderULName": ""
          },{
            "type": false,
            "FounderULINN": "Test",
            "FounderULShare": "Test",
            "FounderULIOGRN": "Test",
            "FounderULName": "Test"
          },
          {
            "type": false,
            "FounderULINN": "",
            "FounderULShare": "",
            "FounderULIOGRN": "",
            "FounderULName": "test"
          }
        ],
        "Beneficiary": [
          {
            "BeneficiaryLName": "",
            "BeneficiaryTel": "",
            "BeneficiaryFName": "",
            "BeneficiaryEmail": "",
            "BeneficiaryMName": "",
            "BeneficiaryINN": "",
            "BeneficiaryRegistration": "",
            "BeneficiaryBD": "",
            "BeneficiaryBPlace": "",
            "BeneficiaryPassportSN": "",
            "BeneficiaryPassPlace": "",
            "BeneficiaryCitizenship": "",
            "BeneficiaryPassDate": "",
            "BeneficiaryPassPCode": "",
            "BeneficiaryDocName": "",
            "BeneficiaryDocNumber": "",
            "BeneficiaryDocDate": ""
          },{
            "BeneficiaryLName": "",
            "BeneficiaryTel": "",
            "BeneficiaryFName": "",
            "BeneficiaryEmail": "",
            "BeneficiaryMName": "",
            "BeneficiaryINN": "",
            "BeneficiaryRegistration": "",
            "BeneficiaryBD": "",
            "BeneficiaryBPlace": "",
            "BeneficiaryPassportSN": "",
            "BeneficiaryPassPlace": "",
            "BeneficiaryCitizenship": "",
            "BeneficiaryPassDate": "",
            "BeneficiaryPassPCode": "",
            "BeneficiaryDocName": "",
            "BeneficiaryDocNumber": "",
            "BeneficiaryDocDate": ""
          }
        ],
        "LPActivityType": [
          {
            "LPActivityTypeName": "",
            "LPActivityTypeRevenueShare": ""
          }
        ],
        "LPPartner": [
          {
            "LPPartnerName": ""
          }
        ],
        "Credit": [
          {
            "Creditor": "",
            "CreditAmount": "",
            "CreditBalance": "",
            "CreditEndDate": ""
          }
        ],
        "BankAccount": [
          {
            "BankAccountNumber": "",
            "BankAccountName": "",
            "BankAccountCode": ""
          }
        ],
        "AppLeasingId": "338",
        "LPFormId": "479",
        "SL": "24",
        "Adv": "10",
        "AppFormDate": "2021-05-19"
      }
    },
    "debug": "{\"msg\":\"\",\"Data\":{\"LPINN\":\"4353478990\",\"AddressFact\":\"testw\",\"OGRN\":\"\",\"WebSite\":\"\",\"OKPO\":\"\",\"Phone\":\"\",\"RegDatev\":\"\",\"StartDate\":\"\",\"EmployeesNumber\":\"\",\"DirectorLName\":\"\",\"DirectorPosition\":\"\",\"DirectorBD\":\"\",\"DirectorFName\":\"\",\"DirectorMName\":\"\",\"SignerLName\":\"\",\"SignerPosition\":\"\",\"SignerBD\":\"2021-05-19\",\"SignerFName\":\"\",\"SignerMName\":\"\",\"DocType\":\"\",\"DocNumber\":\"e\",\"DocDate\":\"\",\"ContactLName\":\"\",\"ContactPosition\":\"\",\"ContactBD\":\"\",\"ContactFName\":\"\",\"ContactMName\":\"\",\"FounderFL\":[{\"type\":true,\"FounderFLFName\":\"\",\"FounderFLShare\":\"\",\"FounderFLMName\":\"\",\"FounderFLBD\":\"\",\"FounderFLBPlace\":\"\",\"FounderFLPassportSN\":\"\",\"FounderFLPassPlace\":\"\",\"FounderFLCitizenship\":\"\",\"FounderFLPassDate\":\"\",\"FounderFLPassPCode\":\"\",\"FounderFLRegistration\":\"\",\"FounderFLLName\":\"222\"},{\"type\":true,\"FounderFLFName\":\"123\",\"FounderFLShare\":\"100\",\"FounderFLMName\":\"12312\",\"FounderFLBD\":\"2000-02-19\",\"FounderFLBPlace\":\"12121\",\"FounderFLPassportSN\":\"1212\",\"FounderFLPassPlace\":\"1212\",\"FounderFLCitizenship\":\"Иностранный гражданин\",\"FounderFLPassDate\":\"2021-05-05\",\"FounderFLPassPCode\":\"12121\",\"FounderFLRegistration\":\"12121\",\"FounderFLLName\":\"цццц\"},{\"type\":true,\"FounderFLFName\":\"123123\",\"FounderFLShare\":\"12321\",\"FounderFLMName\":\"123123\",\"FounderFLBD\":\"\",\"FounderFLBPlace\":\"\",\"FounderFLPassportSN\":\"\",\"FounderFLPassPlace\":\"\",\"FounderFLCitizenship\":\"\",\"FounderFLPassDate\":\"\",\"FounderFLPassPCode\":\"\",\"FounderFLRegistration\":\"\",\"FounderFLLName\":\"123213\"}],\"FounderUL\":[{\"FounderFLFName\":\"\",\"FounderFLShare\":\"e\",\"FounderFLMName\":\"\",\"FounderFLBD\":\"\",\"FounderFLBPlace\":\"\",\"FounderFLPassportSN\":\"\",\"FounderFLPassPlace\":\"\",\"FounderFLCitizenship\":\"\",\"FounderFLPassDate\":\"\",\"FounderFLPassPCode\":\"\",\"FounderFLRegistration\":\"\",\"FounderFLLName\":\"e\",\"FounderULINN\":\"йцу\"},{\"FounderULINN\":\"eйцу\",\"FounderULShare\":\"e\",\"FounderULIOGRN\":\"\",\"FounderULName\":\"\"}],\"Beneficiary\":[{\"BeneficiaryLName\":\"\",\"BeneficiaryTel\":\"\",\"BeneficiaryFName\":\"\",\"BeneficiaryEmail\":\"\",\"BeneficiaryMName\":\"\",\"BeneficiaryINN\":\"\",\"BeneficiaryRegistration\":\"\",\"BeneficiaryBD\":\"\",\"BeneficiaryBPlace\":\"\",\"BeneficiaryPassportSN\":\"\",\"BeneficiaryPassPlace\":\"\",\"BeneficiaryCitizenship\":\"\",\"BeneficiaryPassDate\":\"\",\"BeneficiaryPassPCode\":\"\",\"BeneficiaryDocName\":\"\",\"BeneficiaryDocNumber\":\"\",\"BeneficiaryDocDate\":\"\"}],\"LPActivityType\":[{\"LPActivityTypeName\":\"\",\"LPActivityTypeRevenueShare\":\"\"}],\"LPPartner\":[{\"LPPartnerName\":\"\"}],\"Credit\":[{\"Creditor\":\"\",\"CreditAmount\":\"\",\"CreditBalance\":\"\",\"CreditEndDate\":\"\"}],\"BankAccount\":[{\"BankAccountNumber\":\"\",\"BankAccountName\":\"\",\"BankAccountCode\":\"\"}],\"AppLeasingId\":\"304\",\"LPFormId\":\"479\",\"SL\":\"24\",\"Adv\":\"10\",\"AppFormDate\":\"2021-05-19\",\"action\":\"AppFormSave\",\"Get\":\"AppFormEdit\"}}"
  }

  let err = {
    "s": "success",
    "data": {
      "Error": "Обнаружены ошибки",
      "errors": {
        "main": [
          {
            "LPName": "Отсутсвует LPName",
            "RegDate": "Отсутсвует RegDate",
            "ContractCurrency": "Отсутсвует ContractCurrency",
            "OGRN": "OGRN - Пустая строка или равно 0",
            "WebSite": "WebSite - Пустая строка или равно 0",
            "OKPO": "OKPO - Пустая строка или равно 0",
            "Phone": "Phone - Пустая строка или равно 0",
            "RegDatev": "RegDatev - Пустая строка или равно 0",
            "StartDate": "StartDate - Пустая строка или равно 0",
            "EmployeesNumber": "EmployeesNumber - Пустая строка или равно 0",
            "DirectorLName": "DirectorLName - Пустая строка или равно 0",
            "DirectorPosition": "DirectorPosition - Пустая строка или равно 0",
            "DirectorBD": "DirectorBD - Пустая строка или равно 0",
            "DirectorFName": "DirectorFName - Пустая строка или равно 0",
            "DirectorMName": "DirectorMName - Пустая строка или равно 0",
            "SignerLName": "SignerLName - Пустая строка или равно 0",
            "SignerPosition": "SignerPosition - Пустая строка или равно 0",
            "SignerFName": "SignerFName - Пустая строка или равно 0",
            "SignerMName": "SignerMName - Пустая строка или равно 0",
            "DocType": "DocType - Пустая строка или равно 0",
            "DocDate": "DocDate - Пустая строка или равно 0",
            "ContactLName": "ContactLName - Пустая строка или равно 0",
            "ContactPosition": "ContactPosition - Пустая строка или равно 0",
            "ContactBD": "ContactBD - Пустая строка или равно 0",
            "ContactFName": "ContactFName - Пустая строка или равно 0",
            "ContactMName": "ContactMName - Пустая строка или равно 0"
          },
          {
            "Error": "ИНН (4353478990) (LPINN) не соответсвует формату"
          }
        ],
        "Beneficiary": [
            {
                "BeneficiaryLName": "Test",
                "BeneficiaryTel": "Test",
                "BeneficiaryFName": "Test",
                "BeneficiaryEmail": "Test",
                "BeneficiaryMName": "Test",
                "BeneficiaryINN": "Test",
                "BeneficiaryRegistration": "Test",
                "BeneficiaryBD": "Test",
                "BeneficiaryBPlace": "Test",
                "BeneficiaryPassportSN": "Test",
                "BeneficiaryPassPlace": "Test",
                "BeneficiaryCitizenship": "Test",
                "BeneficiaryPassDate": "Test",
                "BeneficiaryPassPCode": "Test",
                "BeneficiaryDocName": "Test",
                "BeneficiaryDocNumber": "Test",
                "BeneficiaryDocDate": "Test"
            },{
                "BeneficiaryLName": "Test",
                "BeneficiaryTel": "Test",
                "BeneficiaryFName": "Test",
                "BeneficiaryEmail": "Test",
                "BeneficiaryMName": "Test",
                "BeneficiaryINN": "Test",
                "BeneficiaryRegistration": "Test",
                "BeneficiaryBD": "Test",
                "BeneficiaryBPlace": "Test",
                "BeneficiaryPassportSN": "Test",
                "BeneficiaryPassPlace": "Test",
                "BeneficiaryCitizenship": "Test",
                "BeneficiaryPassDate": "Test",
                "BeneficiaryPassPCode": "Test",
                "BeneficiaryDocName": "Test",
                "BeneficiaryDocNumber": "Test",
                "BeneficiaryDocDate": "Test"
            }
          ],
        "FounderFL": [
            {
              "type": true,
              "FounderFLFName": "Test",
              "FounderFLShare": "Test",
              "FounderFLMName": "Test",
              "FounderFLBD": "Test",
              "FounderFLBPlace": "Test",
              "FounderFLPassportSN": "Test",
              "FounderFLPassPlace": "Test",
              "FounderFLCitizenship": "Test",
              "FounderFLPassDate": "Test",
              "FounderFLPassPCode": "Test",
              "FounderFLRegistration": "Test",
              "FounderFLLName": "Test"
            },{},
            {
              "type": true,
              "FounderFLBD": "Test",
              "FounderFLBPlace": "Test",
              "FounderFLPassportSN": "Test",
              "FounderFLPassPlace": "Test",
              "FounderFLCitizenship": "Test",
              "FounderFLPassDate": "Test",
              "FounderFLPassPCode": "Test",
              "FounderFLRegistration": "Test"
            }
          ],
        "FounderUL": [
            {
              "type": false,
              "FounderULINN": "Test",
              "FounderULShare": "Test",
              "FounderULIOGRN": "Test",
            },{},
            {
              "type": false,
              "FounderULINN": "Test",
              "FounderULShare": "Test",
              "FounderULIOGRN": "Test",
            }
          ],
        "LPActivityType": [
          {
            "LPActivityTypeName": "LPActivityTypeName - Пустая строка или равно 0",
            "LPActivityTypeRevenueShare": "LPActivityTypeRevenueShare - Пустая строка или равно 0"
          }
        ],
        "LPPartner": [
          {
            "LPPartnerINN": "Отсутсвует LPPartnerINN",
            "LPPartnerName": "LPPartnerName - Пустая строка или равно 0"
          }
        ],
        "Credit": [
          {
            "Creditor": "Creditor - Пустая строка или равно 0",
            "CreditAmount": "CreditAmount - Пустая строка или равно 0",
            "CreditBalance": "CreditBalance - Пустая строка или равно 0",
            "CreditEndDate": "CreditEndDate - Пустая строка или равно 0"
          }
        ],
        "BankAccount": [
          {
            "BankAccountNumber": "BankAccountNumber - Пустая строка или равно 0",
            "BankAccountName": "BankAccountName - Пустая строка или равно 0",
            "BankAccountCode": "BankAccountCode - Пустая строка или равно 0"
          }
        ]
      }
    },
    "debug": "{\"Error\":\"Обнаружены ошибки\",\"errors\":{\"main\":[{\"LPName\":\"Отсутсвует LPName\",\"RegDate\":\"Отсутсвует RegDate\",\"ContractCurrency\":\"Отсутсвует ContractCurrency\",\"OGRN\":\"OGRN - Пустая строка или равно 0\",\"WebSite\":\"WebSite - Пустая строка или равно 0\",\"OKPO\":\"OKPO - Пустая строка или равно 0\",\"Phone\":\"Phone - Пустая строка или равно 0\",\"RegDatev\":\"RegDatev - Пустая строка или равно 0\",\"StartDate\":\"StartDate - Пустая строка или равно 0\",\"EmployeesNumber\":\"EmployeesNumber - Пустая строка или равно 0\",\"DirectorLName\":\"DirectorLName - Пустая строка или равно 0\",\"DirectorPosition\":\"DirectorPosition - Пустая строка или равно 0\",\"DirectorBD\":\"DirectorBD - Пустая строка или равно 0\",\"DirectorFName\":\"DirectorFName - Пустая строка или равно 0\",\"DirectorMName\":\"DirectorMName - Пустая строка или равно 0\",\"SignerLName\":\"SignerLName - Пустая строка или равно 0\",\"SignerPosition\":\"SignerPosition - Пустая строка или равно 0\",\"SignerFName\":\"SignerFName - Пустая строка или равно 0\",\"SignerMName\":\"SignerMName - Пустая строка или равно 0\",\"DocType\":\"DocType - Пустая строка или равно 0\",\"DocDate\":\"DocDate - Пустая строка или равно 0\",\"ContactLName\":\"ContactLName - Пустая строка или равно 0\",\"ContactPosition\":\"ContactPosition - Пустая строка или равно 0\",\"ContactBD\":\"ContactBD - Пустая строка или равно 0\",\"ContactFName\":\"ContactFName - Пустая строка или равно 0\",\"ContactMName\":\"ContactMName - Пустая строка или равно 0\"},{\"Error\":\"ИНН (4353478990) (LPINN) не соответсвует формату\"}],\"FounderFL\":[{\"FounderFLFName\":\"FounderFLFName - Пустая строка или равно 0\",\"FounderFLShare\":\"FounderFLShare - Пустая строка или равно 0\",\"FounderFLMName\":\"FounderFLMName - Пустая строка или равно 0\",\"FounderFLBD\":\"FounderFLBD - Пустая строка или равно 0\",\"FounderFLBPlace\":\"FounderFLBPlace - Пустая строка или равно 0\",\"FounderFLPassportSN\":\"FounderFLPassportSN - Пустая строка или равно 0\",\"FounderFLPassPlace\":\"FounderFLPassPlace - Пустая строка или равно 0\",\"FounderFLCitizenship\":\"FounderFLCitizenship - Пустая строка или равно 0\",\"FounderFLPassDate\":\"FounderFLPassDate - Пустая строка или равно 0\",\"FounderFLPassPCode\":\"FounderFLPassPCode - Пустая строка или равно 0\",\"FounderFLRegistration\":\"FounderFLRegistration - Пустая строка или равно 0\"},{\"FounderFLBD\":\"FounderFLBD - Пустая строка или равно 0\",\"FounderFLBPlace\":\"FounderFLBPlace - Пустая строка или равно 0\",\"FounderFLPassportSN\":\"FounderFLPassportSN - Пустая строка или равно 0\",\"FounderFLPassPlace\":\"FounderFLPassPlace - Пустая строка или равно 0\",\"FounderFLCitizenship\":\"FounderFLCitizenship - Пустая строка или равно 0\",\"FounderFLPassDate\":\"FounderFLPassDate - Пустая строка или равно 0\",\"FounderFLPassPCode\":\"FounderFLPassPCode - Пустая строка или равно 0\",\"FounderFLRegistration\":\"FounderFLRegistration - Пустая строка или равно 0\"}],\"FounderUL\":[[{\"FounderULIOGRN\":\"Отсутсвует FounderULIOGRN\",\"FounderULName\":\"Отсутсвует FounderULName\",\"FounderULShare\":\"Отсутсвует FounderULShare\",\"FounderFLFName\":\"FounderFLFName - Пустая строка или равно 0\",\"FounderFLMName\":\"FounderFLMName - Пустая строка или равно 0\",\"FounderFLBD\":\"FounderFLBD - Пустая строка или равно 0\",\"FounderFLBPlace\":\"FounderFLBPlace - Пустая строка или равно 0\",\"FounderFLPassportSN\":\"FounderFLPassportSN - Пустая строка или равно 0\",\"FounderFLPassPlace\":\"FounderFLPassPlace - Пустая строка или равно 0\",\"FounderFLCitizenship\":\"FounderFLCitizenship - Пустая строка или равно 0\",\"FounderFLPassDate\":\"FounderFLPassDate - Пустая строка или равно 0\",\"FounderFLPassPCode\":\"FounderFLPassPCode - Пустая строка или равно 0\",\"FounderFLRegistration\":\"FounderFLRegistration - Пустая строка или равно 0\"},{\"FounderULIOGRN\":\"FounderULIOGRN - Пустая строка или равно 0\",\"FounderULName\":\"FounderULName - Пустая строка или равно 0\"}]],\"Beneficiary\":[[{\"BeneficiaryPDL\":\"Отсутсвует BeneficiaryPDL\",\"BeneficiaryLName\":\"BeneficiaryLName - Пустая строка или равно 0\",\"BeneficiaryTel\":\"BeneficiaryTel - Пустая строка или равно 0\",\"BeneficiaryFName\":\"BeneficiaryFName - Пустая строка или равно 0\",\"BeneficiaryEmail\":\"BeneficiaryEmail - Пустая строка или равно 0\",\"BeneficiaryMName\":\"BeneficiaryMName - Пустая строка или равно 0\",\"BeneficiaryINN\":\"BeneficiaryINN - Пустая строка или равно 0\",\"BeneficiaryRegistration\":\"BeneficiaryRegistration - Пустая строка или равно 0\",\"BeneficiaryBD\":\"BeneficiaryBD - Пустая строка или равно 0\",\"BeneficiaryBPlace\":\"BeneficiaryBPlace - Пустая строка или равно 0\",\"BeneficiaryPassportSN\":\"BeneficiaryPassportSN - Пустая строка или равно 0\",\"BeneficiaryPassPlace\":\"BeneficiaryPassPlace - Пустая строка или равно 0\",\"BeneficiaryCitizenship\":\"BeneficiaryCitizenship - Пустая строка или равно 0\",\"BeneficiaryPassDate\":\"BeneficiaryPassDate - Пустая строка или равно 0\",\"BeneficiaryPassPCode\":\"BeneficiaryPassPCode - Пустая строка или равно 0\",\"BeneficiaryDocName\":\"BeneficiaryDocName - Пустая строка или равно 0\",\"BeneficiaryDocNumber\":\"BeneficiaryDocNumber - Пустая строка или равно 0\",\"BeneficiaryDocDate\":\"BeneficiaryDocDate - Пустая строка или равно 0\"}]],\"LPActivityType\":[[{\"LPActivityTypeName\":\"LPActivityTypeName - Пустая строка или равно 0\",\"LPActivityTypeRevenueShare\":\"LPActivityTypeRevenueShare - Пустая строка или равно 0\"}]],\"LPPartner\":[[{\"LPPartnerINN\":\"Отсутсвует LPPartnerINN\",\"LPPartnerName\":\"LPPartnerName - Пустая строка или равно 0\"}]],\"Credit\":[[{\"Creditor\":\"Creditor - Пустая строка или равно 0\",\"CreditAmount\":\"CreditAmount - Пустая строка или равно 0\",\"CreditBalance\":\"CreditBalance - Пустая строка или равно 0\",\"CreditEndDate\":\"CreditEndDate - Пустая строка или равно 0\"}]],\"BankAccount\":[[{\"BankAccountNumber\":\"BankAccountNumber - Пустая строка или равно 0\",\"BankAccountName\":\"BankAccountName - Пустая строка или равно 0\",\"BankAccountCode\":\"BankAccountCode - Пустая строка или равно 0\"}]]}}"
  }



export {mainTemp,FounderFL,FounderUL,Beneficiary,LPActivityType,LPPartner,Credit,BankAccount,AppLeasingId,temp,err}
